import { Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

/** Class used to load the Language from a json-file
* The file need to be located in src/assets
* The default is the german file
*/
@Injectable()
export class GLanguageProvider {

	/** loaded language */
	public language: any = null;
	
	/** file name ending */
	protected languageFileNameEnding: string = "application";

	/** Default file path */
	public languageFileName: string;
	
	 
    constructor(protected http: HttpClient) {}


	/** set the languageFileName */
	setFileName():void{
		this.languageFileName = './assets/de_'+this.languageFileNameEnding+'.json';
	}

	/** return the loaded language */
    public getLanguage(): any {
        return this.language;
	}
	
	
	/** load some other language based on the language abbreviation
	* If abbreviation is not found, english is loaded 
	* @param {string} languageAbbrev - The abbreviation of requests language
	*/
	public loadLanguage(languageAbbrev:string):Promise<any>{
		switch(languageAbbrev){
			case "de": this.languageFileName = './assets/de_'+this.languageFileNameEnding+'.json'; break;
			case "fr": this.languageFileName = './assets/fr_'+this.languageFileNameEnding+'.json'; break;
			case "it": this.languageFileName = './assets/it_'+this.languageFileNameEnding+'.json'; break;
			default: this.languageFileName = './assets/en_'+this.languageFileNameEnding+'.json'; break;
		}
		return this.load();
	}

	/**load the language file using http	 */
    load():Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .get<any>(this.languageFileName)
                .subscribe(response => {
					this.language = response;
                    resolve(true);
                })
        })
    }
}